import React from 'react';
import logo from '../../Assets/jba-logo.png';

const LoadingScreen = () => {
    return (
        <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-gradient-to-br from-purple-50 via-white to-purple-50 overflow-hidden">
            {/* Background Decorative Elements */}
            <div className="absolute top-0 left-0 w-64 h-64 bg-purple-200/20 rounded-full -ml-32 -mt-32 blur-3xl animate-pulse"></div>
            <div className="absolute bottom-0 right-0 w-96 h-96 bg-purple-300/20 rounded-full -mr-48 -mb-48 blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>

            <div className="relative flex flex-col items-center">
                {/* Logo with pulsing effect */}
                <div className="relative mb-8 group">
                    <div className="absolute inset-0 bg-purple-600/10 rounded-full blur-2xl group-hover:bg-purple-600/20 transition-all duration-500 scale-150 animate-pulse"></div>
                    <div className="relative bg-white/40 backdrop-blur-sm p-6 rounded-full border border-white/50 shadow-2xl animate-in zoom-in-50 duration-700">
                        <img
                            src={logo}
                            alt="JBA Logo"
                            className="w-24 h-24 md:w-32 md:h-32 object-contain drop-shadow-md animate-pulse"
                            style={{ animationDuration: '3s' }}
                        />
                    </div>
                </div>

                {/* Brand Name with staggered fade */}
                <div className="text-center space-y-2 animate-in fade-in slide-in-from-bottom-4 duration-1000 delay-300 fill-mode-both">
                    <h1 className="text-xl md:text-2xl font-black text-gray-800 tracking-[0.2em] uppercase">
                        Jain Bandhu Associate
                    </h1>
                    <p className="text-[10px] md:text-xs font-bold text-purple-600 uppercase tracking-[0.5em] opacity-80">
                        Professional Tax Solutions
                    </p>
                </div>

                {/* Modern Progress Indicator */}
                <div className="mt-12 w-48 h-1 bg-gray-100 rounded-full overflow-hidden relative">
                    <div className="absolute inset-0 bg-gradient-to-r from-purple-400 via-purple-700 to-purple-400 w-full animate-loading-bar"></div>
                </div>

                <p className="mt-4 text-[10px] font-bold text-gray-400 uppercase tracking-widest animate-pulse">
                    Loading amazing experiences...
                </p>
            </div>

            <style>{`
        @keyframes loading-bar {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
        .animate-loading-bar {
          animation: loading-bar 2s infinite ease-in-out;
        }
      `}</style>
        </div>
    );
};

export default LoadingScreen;
